'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mergeWith = undefined;

var _rearg2 = require('lodash/rearg');

var _rearg3 = _interopRequireDefault(_rearg2);

var _curry2 = require('lodash/curry');

var _curry3 = _interopRequireDefault(_curry2);

exports.merge = merge;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function merge(object) {
  for (var _len = arguments.length, sources = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    sources[_key - 1] = arguments[_key];
  }

  return Object.assign.apply(Object, [{}, object].concat(sources));
}

var mergeWith = exports.mergeWith = (0, _curry3.default)((0, _rearg3.default)(merge, [1, 0]), 2);